"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDirection = exports.Directions = exports.getDirection = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../utils");
const attrDir = 'dir';
const getDirection = () => ((0, utils_1.getAttrValue)(attrDir, Directions.ltr));
exports.getDirection = getDirection;
var Directions;
(function (Directions) {
    Directions["rtl"] = "rtl";
    Directions["ltr"] = "ltr";
})(Directions = exports.Directions || (exports.Directions = {}));
const useDirection = () => {
    const [direction, setDirection] = react_1.default.useState((0, exports.getDirection)());
    react_1.default.useEffect(() => {
        const disconnect = (0, utils_1.onChangeAttr)(attrDir, setDirection, Directions.ltr);
        return () => disconnect();
    }, []);
    return direction;
};
exports.useDirection = useDirection;
//# sourceMappingURL=useDirection.js.map